'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/10/20.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _AddressChosenComponentThreeLevel = require('../AddressChosenComponent/AddressChosenComponentThreeLevel');

var _AddressChosenComponentThreeLevel2 = _interopRequireDefault(_AddressChosenComponentThreeLevel);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressFilterBar = (_dec = (0, _reduxForm.reduxForm)({
  form: 'addressFilterBarForm',
  fields: ['provinceId', 'cityId', 'addressId']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AddressFilterBar, _Component);

  function AddressFilterBar() {
    (0, _classCallCheck3.default)(this, AddressFilterBar);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AddressFilterBar).call(this));
  }

  (0, _createClass3.default)(AddressFilterBar, [{
    key: 'addressChange',
    value: function addressChange(value, level) {
      var _props = this.props;
      var _props$fields = _props.fields;
      var provinceId = _props$fields.provinceId;
      var cityId = _props$fields.cityId;
      var addressId = _props$fields.addressId;
      var onAddressChange = _props.onAddressChange;

      if (onAddressChange) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onAddressChange(value, level);
        window.scrollTo(0, sTop);
      }
      if (level === 'two') {
        provinceId.onChange(value);
        cityId.onChange();
        addressId.onChange();
      }
      if (level === 'three') {
        cityId.onChange(value);
        addressId.onChange();
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var input = this.refs.searchInput;
      var onSearch = this.props.onSearch;

      if (onSearch) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onSearch(input.value);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./AddressFilterBar.scss');
      var _props2 = this.props;
      var addressId = _props2.fields.addressId;
      var handleSubmit = _props2.handleSubmit;
      var addressData = _props2.addressData;

      return _react2.default.createElement(
        'form',
        { className: styles.component, onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles.addressComponent },
          _react2.default.createElement(
            'span',
            { className: styles.xuanze },
            '区域选择：'
          ),
          _react2.default.createElement(_AddressChosenComponentThreeLevel2.default, { formProps: addressId, style: { marginTop: '14px' },
            labelStyle: { width: '0px', display: 'none' },
            selectStyle: { width: 'calc(100% - 85px)' },
            onAddressChange: this.addressChange.bind(this),
            data: addressData || {} })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.btnComponent },
          _react2.default.createElement(_SubmitBtn2.default, { style: { width: '60px' }, btnClick: handleSubmit, text: '查询' })
        ),
        _react2.default.createElement('img', { className: styles.soo, onClick: this.search.bind(this),
          src: 'http://tupian.goeasy.cn:9999/yipinwang/find.png', alt: '' }),
        _react2.default.createElement('input', { ref: 'searchInput', className: styles.input, placeholder: '请输入体验店名称\\店主名称' })
      );
    }
  }]);
  return AddressFilterBar;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  closeModalFunc: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,
  addressData: _react.PropTypes.object,
  onAddressChange: _react.PropTypes.func,
  onSearch: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = AddressFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddressFilterBar/AddressFilterBar.js
 ** module id = 1306
 ** module chunks = 0
 **/